import endpoints from './endpoints';
import config from '../../configuration';
import {fetch} from '../../lib/fetch';

const {publicFunctionHostKey} = config;

const booking = {
  services: async (dealerId) => {
    const res = await fetch(`${endpoints.services}/${dealerId}`, {
      headers: {
        'x-functions-key': publicFunctionHostKey,
      },
    });

    const json = await res.json();
    return json;
  },
  extras: async (dealerId) => {
    const res = await fetch(`${endpoints.extras}/${dealerId}`, {
      headers: {
        'x-functions-key': publicFunctionHostKey,
      },
    });

    const json = await res.json();
    return json;
  },
};

export default booking;
